import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';

@Component({
  selector: 'asw-emd-search-sub-header',
  templateUrl: './emd-search-sub-header.component.html',
  styleUrls: ['./emd-search-sub-header.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EMDSearchSubHeaderComponent extends SupportComponent {
  /** ページタイトル */
  pageTitle?: string;

  constructor(commonService: CommonLibService) {
    super(commonService);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}
}
